import React, { useEffect } from "react";
import FormUser from "./components/formUser";
import FormEmpresa from "../Cadastro/components/formEmpresa";
import Template from "../Generico/Template";
import TituloPrincipal from "../Generico/TituloPrincipal";
import { Box, Container, Paper } from "@mui/material";

const DadosEmpresa = () => {
  useEffect(() => {
    document.title = "QR Pedir - Cadastro de empresa";
  }, []);

  return (
    <Container>
      <Template documentTitle="Conta da empresa">
        <TituloPrincipal
          title="Conta da empresa"
          subTitle="Edite os dados da empresa ou seus usuários"
        />
        <Paper sx={{ padding: "2rem", mt: 5 }}>
          <Box>
            <FormEmpresa />
          </Box>

          <Box mt={5}>
            <FormUser />
          </Box>
        </Paper>
      </Template>
    </Container>
  );
};

export default DadosEmpresa;
